
export type DeviceStatus = 'Unknown' | 'CertificateInvalid' | 'Inaccessible' | 'LoginFailed' | 'Online' | 'Disabled' | 'Incompatible';
export type LockdownState = 'Unknown' | 'Normal' | 'Lockdown' | 'PartialLockdown';
export type DoorStatus = 'Closed' | 'Opened' | 'TooLong' | 'Unauthorized' | 'Unknown';
export type SwitchState = 'False' | 'True' | 'Unknown';

export interface DataIn extends Record<string, unknown> {
  err?: string;
  status?: DeviceStatus;
  lockdown?: LockdownState;
  doorState?: DoorStatus;
  doorSwitch?: number;
  doorSwitchState?: SwitchState;
}

export type SwitchControl = 'On' | 'Off';

export interface DataOut extends Record<string, unknown> {
  doorSwitch: SwitchControl;
}
